import { getAspectRatioCompound } from '../getAspectRatioCompound';

export function getClientKeywords(
  dynamicAR: boolean,
  assetAR: number,
  playerAspectRatio?: number
) {
  const keywords: Record<string, string | boolean> = {};
  if (assetAR) {
    const { width, height } =
      getAspectRatioCompound(assetAR, [
        [1, 1],
        [16, 9],
        [4, 3],
      ]) ?? {};
    if (width && height) {
      keywords['aa-sch-instream_aspectratio'] = `${width}-${height}`;
    }
  }

  if (dynamicAR) {
    keywords['aa-sch-instream_dynamicenabled'] = dynamicAR;
    keywords['aa-sch-instream_player_aspectratio'] = 'responsive';
  } else if (playerAspectRatio || assetAR) {
    // Fall back to asset aspect ratio if player container's height is 0
    const { width, height } =
      getAspectRatioCompound(playerAspectRatio || assetAR, [
        [1, 1],
        [16, 9],
      ]) ?? {};
    if (width && height) {
      keywords['aa-sch-instream_player_aspectratio'] = `${width}-${height}`;
    }
  }

  return keywords;
}
